import * as React from 'react';
import { DEFAULT_TABLE_PAGE_SIZE } from '../../../common/components/table/constants';

import SurveyActions from '../components/SurveyActions';

const EmptyTableView = () => <p>No surveys.</p>;

export default {
  dataTrackingId: 'surveyId',
  dataLoadingText: 'Loading surveys',
  emptyElement: EmptyTableView,
  pageSize: DEFAULT_TABLE_PAGE_SIZE,
  multiSelectConfig: { selectionType: 'multi' },
  headerConfig: {
    title: 'Surveys',
    Actions: SurveyActions,
  },
  // TODO : This needs to be dynamic
  getDataRequestBody: () => {
    return {};
  },
};

export const checkSurveyRequest = {
  body: {
    pageSize: 1,
    pageNumber: 1,
    query: '',
  },
};
